export default __webpack_public_path__ + "static/media/76.cd3de023.jpeg";